import { render, staticRenderFns } from "./zhimafen.vue?vue&type=template&id=0850b570&"
import script from "./zhimafen.vue?vue&type=script&lang=js&"
export * from "./zhimafen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports